(function () {

  /* ── Resolution selector ── */
  function initResolutionSelector() {
    var sel = document.getElementById('resSelect');
    if (!sel) return;

    function applyResolution(res) {
      var wrapper = document.getElementById('vortex-description');
      if (!wrapper) return;
      var isMobile = window.innerWidth <= 896;
      var cols = ['1080p', '1440p', '4k'];
      cols.forEach(function (r) {
        var cells = wrapper.querySelectorAll('.fps-' + r);
        cells.forEach(function (el) {
          if (isMobile) {
            el.style.display = (r === res) ? 'table-cell' : 'none';
          } else {
            el.style.display = '';
          }
        });
      });
    }

    sel.addEventListener('change', function () {
      applyResolution(sel.value);
    });

    applyResolution(sel.value);

    window.addEventListener('resize', function () {
      applyResolution(sel.value);
    });
  }

  /* ── Reviews slider ── */
  function initReviewsSlider() {
    var wrapper = document.getElementById('vortex-description');
    if (!wrapper) return;

    var slider = wrapper.querySelector('#reviewsSlider');
    var cards = wrapper.querySelectorAll('#reviewsSlider .rc');
    var btnLeft = wrapper.querySelector('.sb.lt');
    var btnRight = wrapper.querySelector('.sb.rg');

    if (!slider || !cards.length) return;

    var current = 0;
    var total = cards.length;
    var autoTimer = null;

    function goTo(index) {
      current = ((index % total) + total) % total;
      cards.forEach(function (c, i) {
        c.classList.toggle('center', i === current);
      });
      var rw = wrapper.querySelector('.rw');
      var rwWidth = rw ? rw.offsetWidth : slider.parentElement.offsetWidth;
      var cardWidth = cards[0].offsetWidth;
      var style = window.getComputedStyle(slider);
      var gap = parseFloat(style.gap) || 16;
      var offset = (rwWidth / 2) - (cardWidth / 2) - current * (cardWidth + gap);
      slider.style.transform = 'translateX(' + offset + 'px)';
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAuto() {
      stopAuto();
      autoTimer = setInterval(next, 3500);
    }

    function stopAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }

    if (btnLeft) {
      btnLeft.addEventListener('click', function () { prev(); startAuto(); });
    }
    if (btnRight) {
      btnRight.addEventListener('click', function () { next(); startAuto(); });
    }

    goTo(0);
    startAuto();

    window.addEventListener('resize', function () { goTo(current); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initResolutionSelector();
      initReviewsSlider();
    });
  } else {
    initResolutionSelector();
    initReviewsSlider();
  }
})();
